<template>
  <input
    :value="value"
    :class="classNames"
    :type="type"
    @blur="$emit('blur', $event.target.value)"
    @input="$emit('input', $event.target.value)"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'text',
    },
  },

  computed: {
    classNames() {
      return ['field'];
    },
  },
};
</script>
